import { styles } from '@web/components/electron-drag-header/styles'
import { isElectron } from '@web/libs/electron/platform'

export function ElectronDragHeader() {
  if (!isElectron()) {
    return null
  }

  return <div style={styles.root} aria-hidden />
}
